export default {
  playGameBtn: 'Play game',
  login: {
    loginTitle: 'Login',
    phoneLabel: 'Phone number',
    passwordLabel: 'Password',
    loginBrn: 'Login',
    registerLink: 'Register'
  },
  register: {
    registerTitle: ' Register',
    nameLabel: 'Profile name',
    usernameLabel: 'Phone number',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm password',
    sourceLabel: 'How you found us',
    sourceSelect: 'select source',
    parentLabel: 'Inviter',
    bankData: 'Bank data',
    bankLabel: 'Bank',
    bankSelect: 'Select bank',
    warningBankOne: '***We recommend',
    warningBankTwo: 'KBank or',
    warningBankThree: 'KTB (fastest speed)***',
    bankAccountNoLabel: 'Bank account number',
    bankAccountNameLabel: 'Bank account name',
    registerBtn: 'Register',
    passwordNotEqualMsg: "Passwords don't match",
    registerSuccessMsg: 'Registration successful',
    nextBtn: 'Next',
    otpLabel: 'OTP code',
    confPhoneLabel: 'Confirm phone number',
    profileLabel: 'User details',
    currencyLabel: 'currency',
    languageTxt: '(English)',
    requiredEngLangMsg: ' Bank account name must be in English only',
    accountFirstname: 'Firstname only',
    accountLastname: 'Lastname only'
  },
  howTo: {
    howToTitle: 'How to instructions',
    walletTitle: 'How to use Wallet',
    playTitle: 'How to enter a game',
    balanceTitle: 'How to check balance',
    bonusTitle: 'How to Receive Bonuses',
    bonusCancelTitle: 'How to end bonuses'
  },
  home: {
    checkBalance: 'Check current balance',
    updateTime: 'Updated at',
    allBaht: '{total} Baht',
    allCoin: '{totalCoin} coin(s)',
    referBonusLabel: 'Invite bonus',
    receiveBtn: 'Receive',
    depositTitle: 'Deposit',
    refreshAllTitle: 'Balance',
    transferTitle: 'Transfer',
    withdrawTitle: 'Withdraw',
    inviteTitle: 'Invite',
    bonusTitle: 'Bonus',
    refundTitle: 'Refund',
    slotAccountLabel: 'Slot',
    viewDataTitle: 'Press to view',
    openAccountTitle: 'Open game account',
    sportAccountLabel: 'Sports + casino',
    lottoAccountLabel: 'Lotto',
    receivedInviteBonusMsg: 'I want to receive invite bonus',
    confirmMsg: 'confirm',
    cancelMsg: 'cancel',
    successMsg: 'success',
    condition1Msg:
      ' If bonus is received, current balance in both wallet and game will be under bonus condition',
    condition2Msg: 'Withrawal Condition : winnings must be more than {}',
    condition3Msg: 'of friend invite bonus amount',
    condition4Msg: 'bonus can be ended when deposit + bonus falls below {}',
    condition5Msg: 'User must end current bonus before making next deposit',
    condition6Msg:
      'Remaining balance in wallet will be under bonus condition if not withdrawan beforehand'
  },
  bonus: {
    bonusTitle: 'Bonus',
    cancelBtn: 'End',
    promoCodePla: 'Promo code',
    searchBtn: 'Search',
    bonusReceived: 'Bonus already received',
    bonusClick: 'Receive bonus',
    currentPromotionMsg: 'Current Promotion',
    cancelBonusConMsg: 'End bonus condition',
    confirmMsg: 'Confirm',
    cancelMsg: 'Cancel',
    cancelOneMsg:
      'Please transfer all funds to main wallet before ending bonuses to prevent loss',
    cancelTwoMsg: '***All in game balance will be cleared***',
    cancelConBonusMsg: 'End bonus condition',
    closeMsg: 'Close',
    bonusType: 'You still have the bonus condition of {}'
  },
  profile: {
    id: 'User number',
    createdAt: 'Member since',
    contact: 'Contact details',
    bankDataTitle: 'Bank details',
    bankAccLabel: 'Bank account name',
    bankLabel: 'Bank',
    accNoLabel: 'Bank account number'
  },
  statement: {
    statementTitle: 'Transaction history',
    uploadStatusBtn: 'Upload status',
    status: 'Status',
    depositMsg: 'Deposit to account',
    bonusMsg: ' Bonus received',
    finishBonusMsg: 'Bonus end',
    withdrawMsg: 'Withdrawal from',
    transferMsg: 'Transfer',
    inProgressMsg: 'processing',
    successMsg: 'success',
    failMsg: 'failed'
  },
  spin: {
    error: {
      NO_CLAIMABLE_COUPON: 'Unable to claim coupon',
      INVALID_PRIZE_CODE: 'Invalid prize',
      INVALID_CODE: 'Invalid coupon code',
      INVALID_COUPON_TYPE: 'Invalid coupon type',
      COUPON_EXPIRED: 'Coupon expired',
      BONUS_REMAINING: 'Bonus condition still active'
    }
  },
  modals: {
    confirmBtn: 'Confirm',
    cancelBtn: 'Cancel',
    saveBtn: 'Save',
    successMsg: 'Success',
    savedMsg: ' Data saved successfully',
    errorMsg: 'An error occured',
    amountLabel: 'Amount (baht)',
    receiveAtLabel: 'Date received',
    transferMsg: 'Transfer successful',
    agreement: {
      title: 'Terms and conditions agreement'
    },
    bonus: {
      title: 'Bonus',
      receiveBtn: 'Receive bonus'
    },
    changePassword: {
      title: 'Edit password',
      oldPasswordLabel: 'old password',
      newPasswordLabel: 'new password',
      newConfirmPasswordLabel: 'confirm new password',
      passwordNotEqualMsg: 'passwords do not match'
    },
    condition: {
      title: 'Conditions'
    },
    deposit: {
      title: 'Top up accounts',
      noteOneTxt: 'Top up accounts must be one of the following',
      noteTwoTxt: '(Wallet balance will be topped up within 1 minute)',
      bank: 'Bank',
      uploadSlipOneTxt: 'Slip upload system will be closed during',
      uploadSlipTwoTxt: '{น-น} of everyday',
      selectImageTxt: 'Please select image',
      selectImageBtn: 'Select image',
      uploadBtn: 'Upload',
      conditionSlip1Txt:
        '** Must be original slip file generated by bank app, NOT a screen capture',
      conditionSlip2Txt:
        '** Slip must be uploaded within 1 hour of transaction time',
      qr1Txt: 'Scan QR code for transfer',
      qr2Txt: 'Please make transfer within',
      qr3Txt: 'minutes',
      qr4Txt:
        '**  If transaction is made outside the designated time, the company will not take responsibility in all cases.',
      cancelBtn: 'Cancel',
      transferBtn: 'Transfer done',
      qrAmountTxt: 'Fill in amount and create QR code',
      qrCondition1Txt:
        '1. When depositing, users must create a NEW qr code for EACH deposit',
      qrCondition2Txt:
        '2. Bank account name and number used for transfer MUST match the registered account',
      qrCondition3Txt:
        '3. If you do not use the account you applied to transfer into If an error occurs, we will not be responsible for any wrong transfers.',
      qrConditionWw1Txt:
        'QR Code can be deposited only 1 time. and transfer within the specified time only',
      qrConditionWw2Txt:
        "Do not make repeated transfers. Do not change the amount. Do not round off decimals. (If you don't comply, the money will not be credited to your account. The system will not top up/refund money to customers in all cases)",
      qrConditionWw3Txt: 'Minimum deposit {minDeposit} baht',
      amountPla: 'Amount',
      qeCreateBtn: 'create QR code',
      linkTruePla: 'paste link',
      linkSendBtn: 'send link',
      refreshAmountMsg: 'Please refresh current balance',
      uploadSuccessMsg: 'Upload successful',
      linkSendMsg: 'Link sent successfully',
      conditionTrueWalletAuto: '(Minimum 2 baht)'
    },
    editProfile: {
      title: 'Edit user details',
      bankAccName: 'Bank account name',
      bankLabel: 'Bank',
      bankAccNoLabel: 'Bank account number'
    },
    invite: {
      title: 'Invite friends',
      linkSendTxt: 'send this link to friends',
      copyTxt: 'copy',
      inviteTurnoverBtn: 'Collect invite turnover',
      fromLabel: 'received from',
      amountLabel: 'amount (baht)',
      createdAtLabel: 'date received'
    },
    promotion: {
      title: 'Promotion',
      promo1Txt: '*** Bonus can be ended if balance+bonus falls below',
      promo2Txt: 'User must end bonus before making next deposit',
      promo3Txt: 'or else deposit will also be under bonus condition',
      receivePromoBtn: 'Receive promotion',
      searchingMsg: 'searching',
      promoNotFoundMsg: 'no promotion found'
    },
    refund: {
      title: 'Refund',
      refundAmountLabel: 'Accrued refund amount',
      receiveBtn: 'receive',
      receiveRefundBtn: 'receive refund',
      refundCon1Txt: 'cannot receive refund',
      refundCon2Txt: 'due to bonus condition',
      refundNotFondTxt: 'No refund request found',
      refundToWallet1Msg: 'In case of receiving refund',
      refundToWallet2Msg:
        'when refund is received, both remaining wallet and in game balance will be under bonus condition',
      refundToWallet3Msg: 'Withdrawal Condition : winnings must be more than',
      refundToWallet4Msg: 'of requested refund amount',
      refundToWallet5Msg: 'bonus can be ended when deposit+bonus falls below',
      refundToWallet6Msg: 'User must end bonus before making next deposit',
      refundToWallet7Msg: 'Remaining funds will also be under bonus condition'
    },
    slip: {
      title: 'Uploads',
      currentStatusTxt: 'Check current status',
      statusLabel: 'status',
      imgLabel: 'image',
      selectView: 'inspect',
      inProgressMsg: 'processing',
      successMsg: 'success',
      failMsg: 'failed',
      incorrectSlipMsg: 'incorrect slip',
      destAccInvalidMsg: 'incorrect destination account number',
      duplicateSlipMsg: 'duplicate slip',
      unstableRefNoMsg: 'invalid Ref number',
      wrongCaptchaMsg: 'Triple consecutive Captcha error',
      invalidSlipMsg: 'Cannot read slip',
      notMatchMsg: 'account number does not match registered account',
      expiredSlipMsg: 'expired slip',
      unknownErrorMsg: 'Error, please contact admin'
    },
    slotAccount: {
      resetPasswordTxt: 'Reset password',
      canNotPlayTxt: 'if user cannot enter game',
      transferToGameLabel: 'transfer to game {} baht',
      haveAmountTxt: 'in game amount {}',
      playGameBtn: 'play game',
      androidAppBtn: 'Android app',
      iosAppBtn: 'iOS app',
      activeBtn: 'Activate'
    },
    transfer: {
      title: 'Transfer',
      selectAccTxt: 'Select account',
      transferFromTxt: 'transfer from',
      walletTxt: 'Wallet {} (baht)',
      transferToTxt: 'to',
      bahtTxt: 'baht',
      minAmountLabel: 'minimum',
      amountPla: 'amount',
      transferBtn: 'transfer',
      selectAccMsg: 'Please select correct account',
      canNotTransferMsg: 'Cannot transfer to or from same account',
      minAmountMsg: 'Minimum amount is'
    },
    withdraw: {
      title: 'Withdraw',
      amountWithdrawTxt: 'withdrawable amount (baht)',
      maxTxt: 'maximum',
      bonusConTxt:
        'Please withdraw all amount if you receive bonus. All remaining credit will be deducted.',
      confBrn: 'confirm',
      maxAmountMsg: 'maximum amount is',
      waiteTransfer: 'please wait for funds to arrive in bank account'
    },
    editBankAccName: {
      title: 'Bank account name',
      warningTxt: 'Edit required : Please use english characters only',
      accNamePla: 'Bank account name (English only)',
      editBtn: 'edit',
      requiredEngLangMsg: 'Bank account name must be in English only'
    }
  },
  bottomMenu: {
    home: 'Home',
    register: 'Register',
    howTo: 'How to use',
    contact: 'Contact us'
  },
  bottomMenuAuth: {
    profile: 'User data',
    condition: 'Conditions',
    statement: 'Transaction history',
    contact: 'Contact us'
  },
  errorMsg: {
    UNAUTHORIZED: 'unauthorized, please log in',
    EXPIRED_AUTH_TOKEN: 'expired authorization token',
    INVALID_USER_1: 'invalid user',
    INVALID_USER_2: 'invalid user',
    INVALID_USER_3: 'invalid user',
    INVALID_USER_4: 'invalid user',
    INVALID_IP: 'invalid IP address',
    NOT_AREASLOT: 'unable to find user in AREASLOT',
    NOT_UFABET: 'unable to find user in UFABET',
    OTP_BLOCK: 'too many requests , please wait a moment',
    OTP_TOKEN_INVALID: 'invalid OTP token',
    OTP_NOT_EXIST: 'OTP does not exist',
    OTP_VERIFIED: 'OTP already verified',
    OTP_EXPIRED: 'expired OTP',
    OTP_CODE_INVALID: 'Invalid OTP code',
    OTP_CODE_VALID: 'Valid OTP',
    EXISTING_USER: 'user number already exists',
    EXISTING_BANK: 'bank account already exists',
    INVALID_USER_INFO: 'invalid user info',
    UNVERIFIED_OTP: 'please verify phone number via OTP code',
    GAME_ACTIVATION_FAIL: 'game activation failed',
    INVALID_BANK: 'invalid bank information',
    BANK_ACCOUNT_NAME_ENG: 'Bank account name must be in English only',
    REGISTER_FAIL: 'Registration failed',
    NO_USER: 'user not found',
    WRONG_PASSWORD: 'incorrect password',
    REQUEST_LIMIT: 'too many requests, please wait a moment',
    WRONG_CREDENTIAL: ' incorrect phone number/password',
    INACTIVE_USER: 'this user has been deactivated',
    LOGIN_FAIL: 'unable to login at this time',
    BONUS_REMAINING: 'Bonus condition still active',
    BONUS_ALREADY_ACTIVE: 'Bonus is already active',
    BONUS_MAX_CLAIMED: 'Bonus already claimed',
    BONUS_CONDITION: 'Condition for bonus end not met',
    BONUS_CLEAR: 'Bonus ended',
    INVITE_COLLECT: 'System will accumulate automatically',
    INTERNAL_SERVER_ERROR: 'System error, please try again',
    INVITE_INACTIVE: 'Inactivate friend invite',
    NO_INVITE_BONUS: 'no friend invite bonus found',
    NO_INVITEE_PLAY_INFO: 'no friend gameplay activity found',
    INVITE_BONUS_SUCCESS: 'successfully received invite bonus',
    INVITE_BONUS_FAIL: 'No invite bonus received',
    OK: 'ok',
    KEY_MISSING: 'key not found',
    KEY_INVALID: 'invalid key',
    SUCCESS: 'success',
    OTP_SEND_FAIL: 'cannot send OTP',
    OTP_VERIFY_FAIL: 'cannot verify OTP',
    NO_DATA: 'no data',
    NO_PROMOTION: 'no promotion found',
    PROMOTION_RECEIVED: 'promotion already received',
    BONUS_FULL: 'Maximum number of promotions reached',
    QR_FAIL: 'unable to generate QR code, please try again',
    NO_REFUND: 'no refund available',
    REFUND_CONDITION: 'user refund condition not met',
    REFUND_SUCCESS: 'refund successfully received',
    REFUND_INACTIVE: 'refund system inactive',
    REFUND_MINIMUM: 'minimum refund amount must be more than 0 baht',
    NO_BANK: 'no bank account details found for this user',
    NO_WALLET: 'no wallet information found for this user',
    SLOT_ALREADY_ACTIVE: 'game is already active',
    SLOT_ACTIVATE_FAIL: 'game activation failed',
    SLOT_NO_ACCOUNT: 'no game user account found',
    SLOT_RESET_PASSWORD_FAIL: 'password reset failed',
    TRANSFER_MINIMUM: 'Minimum transfer amount must be more than 0',
    NO_GAME: 'no game data',
    MONEY_NOT_ENOUGH: 'insufficient funds',
    TRANSFER_FAIL: 'failed transfer; funds have been returned to wallet',
    SLIP_UPLOAD_FAIL: 'upload failed',
    REQUEST_LIMIT_1MIN: 'too many requests , please wait about 1 minute',
    SLIP_NO_FILE: 'no file uploaded',
    SLIP_INVALID_FILE: 'invalid image file',
    TRUELINK_DUPLICATE: 'duplicate link',
    TRUELINK_INVALID: 'invalid or used link',
    PHONE_NUMBER_REQUIRE_10_DIGIT: 'The phone number must support 10 digits'
  }
}
